import { Lightning } from '@lightningjs/sdk'

import {
  getColor,
  grey200,
  grey50,
  grey600,
  grey920,
  grey960,
  primary500,
  white,
} from '../../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../../constants/fonts'
import { BORDER_RADIUS } from '../../constants/general'
import { getIcon } from '../../utils/image'

export const PRODUCT_ITEM_MARGIN = 24

export default class ProductItem extends Lightning.Component {
  private _period: string

  static _template() {
    return {
      w: 610,
      h: 137,
      rect: true,
      clipping: true,
      color: getColor(primary500),
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: BORDER_RADIUS,
      },
      flexItem: {
        marginBottom: PRODUCT_ITEM_MARGIN,
      },
      Fill: {
        x: -1,
        y: -1,
        w: (w) => w + 2,
        h: (h) => h + 2,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: BORDER_RADIUS,
          fillColor: getColor(grey920),
        },
      },
      Wrapper: {
        w: (w) => w,
        h: (h) => h,
        flex: {
          alignItems: 'center',
          direction: 'row',
        },
        TextCont: {
          flex: {
            alignItems: 'center',
            direction: 'column',
          },
          Label: {
            x: 32,
            w: 550,
            text: {
              text: '',
              textColor: getColor(grey50),
              fontSize: 32,
              fontFace: UniNeueBold,
              maxLines: 1,
              maxLinesSuffix: '...',
              wordWrapWidth: 744,
            },
          },
          Price: {
            x: 32,
            w: 550,
            text: {
              text: '',
              textColor: getColor(grey200),
              fontSize: 28,
              fontFace: UniNeueRegular,
              maxLines: 1,
              maxLinesSuffix: '...',
              wordWrapWidth: 744,
            },
          },
        },
        Icon: {
          color: getColor(grey50),
          texture: Lightning.Tools.getSvgTexture(getIcon('icon-caret-right'), 32, 32),
        },
      },
    }
  }

  set label(v: string) {
    this.tag('Label').patch({ text: v })
  }

  get label() {
    return this.tag('Label').text.text
  }

  set price(v: string) {
    this.tag('Price').patch({ text: v })
  }

  get price() {
    return this.tag('Price').text.text
  }

  get wrapper() {
    return this.tag('Wrapper')
  }

  get fill() {
    return this.tag('Fill')
  }

  set period(v: string) {
    this._period = v
  }

  get period() {
    return this._period
  }

  _focus() {
    this.focusItem(true)
  }

  _unfocus() {
    this.focusItem(false)
  }

  focusItem(isFocused: boolean) {
    if (isFocused) {
      this.fireAncestors('$onFocusProduct', this.period)
    }

    this.fill.patch({
      x: isFocused ? 6 : -1,
      w: isFocused ? (w) => w - 5 : (w) => w + 2,
      shader: { fillColor: isFocused ? getColor(grey50) : getColor(grey920) },
    })

    this.wrapper.patch({
      TextCont: {
        Label: { text: { textColor: isFocused ? getColor(grey960) : getColor(white) } },
        Price: { text: { textColor: isFocused ? getColor(grey600) : getColor(grey200) } },
      },
      Icon: { color: isFocused ? getColor(grey960) : getColor(grey50) },
    })
  }
}
